import styled from 'styled-components';

import { cssBreakpoints } from 'theme/theme';

export const CarouselContainer = styled.div`
  position: relative;
`;

/**
 * The purpose of this div is to set `overflow: hidden` around the slider items
 * but not around the navigation.
 */
export const CarouselSliderContainer = styled.div`
  margin-bottom: 30px;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const CarouselSlider = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  transition: transform 0.5s cubic-bezier(0.075, 0.82, 0.165, 1);
  will-change: transform;
  transform: translateX(calc(100% * var(--current-page) * -1));
`;

export const CarouselSlide = styled.div`
  position: absolute;

  width: calc(
    100% / var(--slides-per-page) - (var(--slides-per-page) - 1) * var(--gutter)
  );
  height: 100%;

  left: calc(
    100% * var(--index) / var(--slides-per-page) + var(--gutter) *
      var(--nth-index)
  );
  overflow: hidden;

  --nth-index: var(--nth-index-xs);
  --slides-per-page: var(--slides-per-page-xs);

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    --nth-index: var(--nth-index-sm);
    --slides-per-page: var(--slides-per-page-sm);
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    --nth-index: var(--nth-index-md);
    --slides-per-page: var(--slides-per-page-md);
  }

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    --nth-index: var(--nth-index-lg);
    --slides-per-page: var(--slides-per-page-lg);
  }
`;
